var template = require('../templates/VehicleModal.ejs');
var ModalFormView = require('commons/views/ModalForm');

require('models/Vehicle');

module.exports = ModalFormView.extend({
    initialize: function(options) {
        ModalFormView.prototype.initialize.apply(this, [_.extend(options, {
            template: template
        })]);
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/VehicleModal.js